import { useEffect, useRef, useState } from 'preact/hooks';
import { Icons } from './Icon';
import { registerPasskey } from '../lib/webauthn-client';
import { apiPost } from '../lib/api';

export function SettingsMenu() {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<string | null>(null);
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    function onDown(e: MouseEvent) {
      if (!rootRef.current?.contains(e.target as Node)) setOpen(false);
    }
    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape') setOpen(false);
    }
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDown);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  async function addDevice() {
    setBusy(true);
    setMsg(null);
    try {
      const { deviceName } = await registerPasskey();
      setMsg(`Added: ${deviceName}`);
    } catch (e) {
      setMsg(`Failed: ${(e as Error).message}`);
    } finally {
      setBusy(false);
    }
  }

  async function logout() {
    await apiPost('/api/auth/logout', {});
    window.location.replace('/login');
  }

  return (
    <div class="settings" ref={rootRef}>
      <button
        class="seg-btn icon-btn"
        onClick={() => setOpen((x) => !x)}
        aria-label="Settings"
      >
        <Icons.Settings size={14} />
      </button>
      {open && (
        <div class="settings-menu" role="menu">
          <button
            class="settings-item"
            onClick={addDevice}
            disabled={busy}
            role="menuitem"
          >
            <Icons.Plus size={14} /> Add device
          </button>
          <button class="settings-item" onClick={logout} role="menuitem">
            <Icons.LogOut size={14} /> Sign out
          </button>
          {msg && <div class="settings-msg mono">{msg}</div>}
        </div>
      )}
    </div>
  );
}
